// emailSubscriptions/actions.js
import actionTypes from './actionTypes';

const changeSubscriptionFilter = (value, categoryOptions) => ({
    type: actionTypes.CHANGE_SUBSCRIPTION_FILTER,
    payload: {
        value,
        categoryOptions
    }
});

const changeCategorySelection = (id, isChecked, categoryOptions) => ({
    type: actionTypes.CHANGE_CATEGORY_SELECTION,
    payload: {
        id,
        isChecked,
        categoryOptions
    }
});

const changeTeamSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_TEAM_SELECTION,
    payload: {
        teamId: id,
        isChecked,
        availableTeams
    }
});

const changeDivisionSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_DIVISION_SELECTION,
    payload: {
        divisionId: id,
        isChecked,
        availableTeams
    }
});

const requestCategories = () => ({
    type: actionTypes.REQUEST_CATEGORIES
});

const categoriesResponse = (success, categories, errors) => ({
    type: actionTypes.CATEGORIES_RESPONSE,
    payload: {
        success,
        categories,
        errors
    }
});

const requestSave = () => ({
    type: actionTypes.REQUEST_SAVE
});

const saveResponse = (success, errors) => ({
    type: actionTypes.SAVE_RESPONSE,
    payload: {
        success,
        errors
    }
});

const hydrateSubscriptions = profile => ({
    type: actionTypes.HYDRATE_SUBSCRIPTIONS,
    payload: profile
});

export default {
    changeSubscriptionFilter,
    changeCategorySelection,
    changeTeamSelection,
    changeDivisionSelection,
    requestCategories,
    categoriesResponse,
    requestSave,
    saveResponse,
    hydrateSubscriptions
};